<template>
  <el-switch @change="change" v-model="hasLcrModule"></el-switch>
</template>

<script>
export default {
  data() {
    return {
      hasLcrModule: false
    }
  },
  beforeMount() {
    this.hasLcrModule = (this.params.data.has_lcr === 1)
  },
  methods: {
    change(val) {
      let data = {
        value: val,
        userId: this.params.data.user_id
      }
      this.params.props.actionsHandler('setUserHasLcrModule', data)
    }
  }
}
</script>
